import create from "zustand";
export const languageStore = create((set) => ({
  language: "KR",
  setLanguage: (lang) => set((state) => ({ language: lang })),
}));
